import Vue from 'vue';
import isNil from 'lodash/isNil';
import router from '@/router';
import settingConst from '@/constants/setting';
import DeviceRegistrationNmsAPI from '@/api/settings/common/device-registration-nms';
import DeviceRegistrationAmsAPI from '@/api/settings/common/device-registration-ams';
import AmsExecutionAPI from '@/api/ams/execution';
import MapAPI from '@/api/topologymap/common';
import { MapInfo } from '@/views/topologymap/js/maps';
import msgUtil from '@/utils/message';
import ActionProcess from './ActionProcess';

const SET_AUTO_MOVE_SETTING_MENU_INFO = 'setAutoMoveMenuInfo';
const ADD_ACTION_TASK = 'addActionTask';
const REMOVE_ACTION_TASK = 'removeActionTask';
const actionVm = new Vue();

/**
 * 기능 수행 관련 상태 관리 store
 * @author Ju
 */
const action = {
  state: {
    actionTasks: [],
  },
  mutations: {
    /**
     * 기능 수행 Task를 추가한다.
     */
    [ADD_ACTION_TASK]: (state, task) => {
      state.actionTasks.push(task);
    },
    /**
     * 기능 수행 Task를 삭제한다.
     */
    [REMOVE_ACTION_TASK]: (state, task) => {
      const taskIndex = state.actionTasks.findIndex((item) => item.taskName === task.taskName);
      state.actionTasks.splice(taskIndex, 1);
    },
  },
  /* eslint-disable no-underscore-dangle */
  actions: {
    /**
     * 모델링 수행 Task를 생성한다.
     * @author Ju
     * @param  {[type]} store   [description]
     * @param  {[type]} scanIds [description]
     * @return {[type]}         [description]
     */
    executeNetworkModelingTask(store, scanIds) {
      const params = {
        scanIds,
      };
      const handleComplete = (process) => {
        store.dispatch(SET_AUTO_MOVE_SETTING_MENU_INFO, settingConst.autoMoveMenuConst.MODELING);
        process.remove();
      };
      const run = (process) => {
        DeviceRegistrationNmsAPI.getModelingScanProgressRate(scanIds).then((response) => {
          if (response.data.success) {
            const progressRate = isNil(response.data.data) ? 0 : response.data.data * 100;
            process.setProgressRate(progressRate);
            if (progressRate >= 100 && !process.isComplete) {
              process.complete();
              actionVm.$message(msgUtil.getResultMsgData('완료', '네트워크 모델링', true));
              store.dispatch('setForceNetworkModelingResultLoad', true);
            }
          }
        });
      };
      const repeatCallback = (process) => {
        process.complete();
        actionVm.$message(msgUtil.getResultMsgData('완료', '시간 초과로 모델링 수행', false));
      };
      const process = new ActionProcess(store, '네트워크 모델링', params, false, handleComplete, 3, run, 300, repeatCallback);
      process.start();
    },
    /**
     * 자동화 모델링 수행 Task를 생성한다.
     * @author jeee12
     * @param  {[type]} store    [description]
     * @param  {[type]} rangeIds [description]
     * @return {[type]}          [description]
     */
    executeAmsModelingTask(store, rangeIds) {
      const params = {
        rangeIds,
      };
      const handleComplete = (process) => {
        store.dispatch(SET_AUTO_MOVE_SETTING_MENU_INFO, settingConst.autoMoveMenuConst.AMS_MODELING);
        process.remove();
      };
      const run = (process) => {
        DeviceRegistrationAmsAPI.getAmsModelingProgressRate(rangeIds).then((response) => {
          if (response.data.success) {
            const progressRate = isNil(response.data.data) ? 0 : response.data.data * 100;
            process.setProgressRate(progressRate);
            if (progressRate >= 100 && !process.isComplete) {
              process.complete();
              actionVm.$message(msgUtil.getResultMsgData('완료', '자동화 모델링', true));
              store.dispatch('setForceAmsModelingResultLoad', true);
            }
          }
        });
      };
      const repeatCallback = (process) => {
        process.complete();
        actionVm.$message(msgUtil.getResultMsgData('완료', '시간 초과로 모델링 수행', false));
      };
      const process = new ActionProcess(store, '자동화 모델링', params, false, handleComplete, 3, run, 300, repeatCallback);
      process.start();
    },
    /**
     * 자동화 수행 > 트리거 즉시 수행 Task를 생성한다.
     * @author jeee12
     * @param  {[type]} store         [description]
     * @param  {[type]} triggerExecId [description]
     * @return {[type]}               [description]
     */
    executeTriggerTask(store, triggerExecId) {
      const params = {
        triggerExecId,
      };
      const AMS_SLIDING_POPUP = {
        id: 'amsSlidingPopup',
        children: {
          // 2depth
          RESULT: {
            id: 'result',
            children: {
              // 3depth
              TRIGGER: {
                id: 'TRIGGER',
              },
            },
          },
        },
      };
      const AMS_TRG_RESULT_MENU_INFO = [AMS_SLIDING_POPUP, AMS_SLIDING_POPUP.children.RESULT, AMS_SLIDING_POPUP.children.RESULT.children.TRIGGER];

      const handleComplete = (process) => {
        router.push({ path: '/work' });
        const showSettingView = store.getters.showSettingView;
        if (showSettingView) {
          store.dispatch('closeSettingView');
        }
        store.dispatch(SET_AUTO_MOVE_SETTING_MENU_INFO, AMS_TRG_RESULT_MENU_INFO);
        store.dispatch('setForceAmsTriggerResultLoad', true);
        process.remove();
      };
      const run = (process) => {
        AmsExecutionAPI.getDirectTriggerExecProgressRate({ triggerExecId }).then((response) => {
          if (response.data.success) {
            const progressRate = isNil(response.data.data) ? 0 : response.data.data * 100;
            process.setProgressRate(progressRate);
            if (progressRate >= 100 && !process.isComplete) {
              process.complete();
              actionVm.$message(msgUtil.getResultMsgData('완료', '템플릿 수행', true));
              // store.dispatch('setForceAmsTriggerResultLoad', true);
            }
          }
        });
      };
      const repeatCallback = (process) => {
        process.complete();
        actionVm.$message(msgUtil.getResultMsgData('완료', '시간 초과로 템플릿 수행', false));
      };
      const process = new ActionProcess(store, '템플릿', params, false, handleComplete, 3, run, 300, repeatCallback);
      process.start();
    },
    /**
     * 자동맵(연결정보) 모델링 Task
     * @author KangBongHun(toto1323)
     * @param  {[type]} store  [description]
     * @param  {[type]} params [description]
     * @return {[type]}        [description]
     */
    autotopologyModelingTask(store, scheduleId) {
      const params = {
        scheduleId,
      };

      const run = (process) => {
        MapAPI.getAutotopologyExecProgressRate(scheduleId).then((response) => {
          if (response.data.success) {
            const progressRate = isNil(response.data.data) ? 0 : response.data.data;
            process.setProgressRate(progressRate);
            if (progressRate >= 100 && !process.isComplete) {
              process.complete();
              // actionVm.$message(msgUtil.getResultMsgData('완료', '연결정보 수집', true));
              // if (MapInfo.getInstance() && MapInfo.getInstance().getCanvas()) {
              //   MapInfo.getInstance().getCanvas().refreshMap(mapId);
              // }
              // process.remove();
            }
          }
        });
      };
      const repeatCallback = (process) => {
        process.complete();
        actionVm.$message(msgUtil.getResultMsgData('완료', '시간 초과로 연결정보 수집', false));
      };
      const process = new ActionProcess(store, '연결정보 수집', params, true, null, 1, run, 300, repeatCallback);
      process.start();
      MapInfo.getInstance().addAutomapProcess(process);
    },
  },
  /* eslint-enable no-underscore-dangle */
};

export default action;



// WEBPACK FOOTER //
// ./src/store/modules/action/index.js